const convertDashToCamelCase = (str) => str.replace(/-([a-z])/g, (m, s) => s.toUpperCase());

/**
 * convert object keys with whatever converter
 */
export const convertObjectKeys = (converter) => (o) =>
  Object.keys(o).reduce((c, k) => {
    let objValue = o[k];

    if (Object.prototype.toString.apply(o[k]) === '[object Array]') {
      const newO = [];
      for (let i = 0; i < o[k].length; i++) {
        newO[i] = convertObjectKeys(converter)({...o[k][i]});
      }

      objValue = newO;
    }

    if (Object.prototype.toString.apply(o[k]) === '[object Object]') {
      objValue = convertObjectKeys(converter)({...o[k]});
    }

    return {
      ...c,
      [converter(k)]: objValue,
    };
  }, {});

/**
 * convert dashed object keys to camelCase
 */
export const convertObjectKeysToCamelCase = convertObjectKeys(convertDashToCamelCase);

export const objectsEqual = (o1, o2) =>
  Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every((p) => o1[p] === o2[p]);

export const parseValueToString = (obj) => {
  const res = {...obj};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in res) {
    if (Object.hasOwnProperty.call(res, key)) {
      res[key] = res[key] ? res[key].toString() : res[key];
    }
  }
  return res;
};

export const objMapper = (data, mapper) => {
  const res = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      const newKey = mapper[key];
      if (newKey) {
        res[newKey] = value;
      }
    }
  }
  return res;
};
